import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

import * as errorUtils from '../../../modules/utility/global-utils';
import { CacheCountryService } from '../../../services/cacheCountries.service';
import { CountryApiService } from '../../petitioner/services/country.service';
import { ConfirmationService } from "primeng/api";

import { Store } from '@ngrx/store';
import { Subject, combineLatest } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';
import { LcaService } from 'src/app/services/lca.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-employment-wage-information',
  templateUrl: './employment-wage-information.component.html',
  styleUrls: ['./employment-wage-information.component.scss']
})
export class EmploymentWageInformationComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() employmentWageForm: FormGroup;
  // @Input() employeeReset;
  @Input() editLcaWageData;
  @Input() socCode;
  employerInfoFormChangesSubscription: any;
  placeOfEmploymentInfoMaxCount: number = 3 //default max;
  yearList = new Date().getFullYear();
  stateYearList = [];
  listStates: any[];
  listCounty0: any[];
  listCounty1: any[];
  listCounty2: any[];
  changedWage: any;
  wageResults: any[] = [];
  wageResultsEducation: any[] = [];
  isDuplicateLCA: boolean = false;

  destroy$ = new Subject();
  countyAreaList: any[] = []
  constructor(private fb: FormBuilder,
              protected store: Store<any>,
              private cacheCountryService: CacheCountryService,
              private apiService: CountryApiService,
              private confirmationService: ConfirmationService,
              private lcaApis: LcaService,
              private toastr: ToastrService,
              private cdf: ChangeDetectorRef) {}
              
  ngOnChanges(changes: SimpleChanges){
    if(changes.editLcaWageData && changes.editLcaWageData.currentValue && changes.editLcaWageData.currentValue.placeList.length > 0){
      this.employmentWageForm.controls.employement['controls'] = [];
      changes.editLcaWageData.currentValue.placeList.forEach((item, index) =>{
        this.handlePlaceOfEmptInfoCount(1);
        this.employement().controls[index].patchValue({
          secEntBusName: item.secEntBusName,
          noOfWorkers: item.noOfWorkers,
          addressLine1: item.addressDTO.addressLine1,
          addressLine2: item.addressDTO.addressLine2,
          // county: item.addressDTO.county,
          state: item.addressDTO.stateProvinceCode,
          city: item.addressDTO.city,
          postalCode: item.addressDTO.postalCode,
          wageRangeFrom: item.wageRangeFrom,
          wageRangeTo: item.wageRangeTo,
          wageRangeTypeCode: item.wageRangeTypeCode,
          prvlWageRate: item.prvlWageRate,
          prvWageTypeCode: item.prvWageTypeCode,
          pwdTrackNumber: item.pwdTrackNumber,
          pwdOesSourceLevelId:item.pwdOesSourceLevelId,
          pwdOesSourceYear: item.pwdOesSourceYear,
          countyAreaName: item?.countyAreaName,
          pwdOtherSourceId: item.pwdOesSourceYear,
          pwdOtherSourceYear: item.pwdOtherSourceYear,
          otherPwdSurveyName: item.otherPwdSurveyName,
          otherPwdSurveyPublshr: item.otherPwdSurveyPublshr,
          prvlWageSourceId: item.prvlWageSourceId,
          isEmprReprAttorney: item.secEntBusName !== '' ? true : false
        });

        this.onChangeSecondaryEntity(item.secEntBusName !== '' ? true : false, index);

        if(item.prvlWageSourceId === 'PWDLABDEPT'){
          this.employement().controls[index].patchValue({
            pwdIssuedByLabor: true
          });
          this.onChangePrevailingWage(true, index, 'pwd');
        } else if(item.prvlWageSourceId === 'PWDOESPROG'){
          this.employement().controls[index].patchValue({
            OESProgram: true
          });
          this.onChangePrevailingWage(true, index, 'oes');
        } else if(item.prvlWageSourceId === 'PWDOTHERLEGTSRC'){
          this.employement().controls[index].patchValue({
            otherThanOES: true
          });
          this.onChangePrevailingWage(true, index, 'other');
          if(item.pwdOtherSourceId === 'OTHER'){
            this.employement().controls[index].get('otherPwdSurveyName').enable();
            this.employement().controls[index].get('otherPwdSurveyPublshr').enable();
            this.employement().controls[index].get('otherPwdSurveyName').setValidators([Validators.required]);
            this.employement().controls[index].get('otherPwdSurveyPublshr').setValidators([Validators.required]); 
          }
        }
        // this.onChangeCountry(item.addressDTO.county);
        this.onChangeCountry('USA');        
        this.onChangeState(item.addressDTO.stateProvinceCode, index, true, item);

        this.employement().controls[index].patchValue({
          // state: item.addressDTO.stateProvinceCode,
          county: item.addressDTO.county,
          pwdTrackNumber: item.pwdTrackNumber,
          pwdOesSourceLevelId:item.pwdOesSourceLevelId,
          pwdOesSourceYear: item.pwdOesSourceYear,
          countyAreaName: item?.countyAreaName,
          pwdOtherSourceId: item.pwdOtherSourceId,
          pwdOtherSourceYear: item.pwdOtherSourceYear,
          otherPwdSurveyName: item.otherPwdSurveyName,
          otherPwdSurveyPublshr: item.otherPwdSurveyPublshr
        });

        // Modifying this to match the FLC data center format of source year (Ex: 7/2022 - 6/2023) previously it was just an year
        if (item.pwdOesSourceYear && item.pwdOesSourceYear.toString().length == 4) {
          let formattedSourceYear = `7/${item.pwdOesSourceYear} - 6/${parseInt(item.pwdOesSourceYear)+1}`;
          this.employement().controls[index].get('pwdOesSourceYear').setValue(formattedSourceYear);
        }

        if (item.pwdOtherSourceYear && item.pwdOtherSourceYear.toString().length == 4) {
          let formattedSourceYear = `7/${item.pwdOtherSourceYear} - 6/${parseInt(item.pwdOtherSourceYear)+1}`;
          this.employement().controls[index].get('pwdOtherSourceYear').setValue(formattedSourceYear);
        }
        //added settimeout bcoz of the async issue on loading liststates
        // setTimeout(() => {
        //   this.getWageLevels(index, item.addressDTO.county, item.addressDTO.stateProvinceCode);
        // }, 1000);
        
      });
      this.cdf.detectChanges();
    }
  }

  ngOnInit(): void {
    for(let i = this.yearList; i > 2000; i--){
      // Modifying this to match the FLC data center format of source year (Ex: 7/2022 - 6/2023) previously it was just an year
      let currentDuration = `7/${i} - 6/${i+1}`
      this.stateYearList.push(currentDuration);
    }
    this.onChangeCountry('USA');
    this.isDuplicateLCA = sessionStorage.getItem("isDuplicateLCA") === 'true';
  }
   
  ngAfterViewInit() {
    if(this.employmentWageForm.get("employement").value.length === 0){
      this.handlePlaceOfEmptInfoCount(1);
    }
  }

  onChangeCountry(countryCode: string) {
    this.apiService.getStates(countryCode)
    .pipe(takeUntil(this.destroy$))    
    .subscribe((states: []) => {
      this.listStates = states;
    });
  }

  onChangeState(stateCode: string, index: any, getWageLevels: boolean = false, item: any ={}) {
    this.apiService.getCounties(stateCode)
    .pipe(takeUntil(this.destroy$))
    .subscribe((county: []) => {
      if(index===0){
        this.listCounty0 = county;
      } else if(index===1){
        this.listCounty1 = county;
      } else if(index===2){
        this.listCounty2 = county;
      }
      if(getWageLevels && item){
        this.getWageLevels(index, item.addressDTO.county, item.addressDTO.stateProvinceCode);
      }
    });
  }

  employement(): FormArray {
    return this.employmentWageForm.get("employement") as FormArray
  }
 
  newEmployement(): FormGroup { 
    return this.fb.group({
      isEmprReprAttorney: [true],
      secEntBusName: ['', [Validators.minLength(5), Validators.required]],
      noOfWorkers: ['', [Validators.pattern('^[0-9]*$'),Validators.required]],
      addressLine1: ['', Validators.required],
      addressLine2: [''], 
      // country: ['', Validators.required],
      county: ['', Validators.required],
      state: ['', Validators.required],
      city: ['', [Validators.required]],
      postalCode: ['', Validators.required],
      wageRangeFrom: ['', [Validators.pattern('^[0-9 -]+$'), Validators.required]],
      wageRangeTo: ['', [Validators.pattern('^[0-9 -]+$'),]],
      wageRangeTypeCode: ['', Validators.required],
      prvlWageRate: ['', Validators.required],
      prvWageTypeCode: ['', Validators.required],
      pwdIssuedByLabor: ['', [Validators.required]],
      pwdTrackNumber: [{value: '', disabled: true}, [Validators.pattern('^[a-zA-Z0-9]+$')]],
      OESProgram: ['', [Validators.required]],
      pwdOesSourceLevelId: [{value: '', disabled: true}],
      pwdOesSourceYear: [{value: '', disabled: true}],
      pwdOtherSourceId: [{value: '', disabled: true}],
      pwdOtherSourceYear: [{value: '', disabled: true}],
      countyAreaName: [{value: null, disabled: true}],
      otherThanOES: ['', [Validators.required]],
      otherPwdSurveyName: [{value: '', disabled: true}],
      otherPwdSurveyPublshr: [{value: '', disabled: true}],
      prvlWageSourceId: [''],
    }) 
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  handlePlaceOfEmptInfoCount(mode){
    if(mode == 1){
      this.employmentWageForm.get("employement").value.length <3? this.employement().push(this.newEmployement()):'';
    }
  }

  removeEmployement(empIndex:number) {
    this.employement().removeAt(empIndex);
  }

  onChangePrevailingWage(event, index, value){
    if(event){
      switch(value){
        case 'pwd':

                  this.removePrevailingWage(index);
                  this.employement().controls[index].get('OESProgram').clearValidators();
                  this.employement().controls[index].get('otherThanOES').clearValidators();
                  this.employement().controls[index].get('OESProgram').setValue('');
                  this.employement().controls[index].get('otherThanOES').setValue('');
                  this.employement().controls[index].get('pwdTrackNumber').setValidators([Validators.pattern('^[a-zA-Z0-9]+$'), Validators.required]);
                  this.employement().controls[index].get('pwdTrackNumber').enable();
                  this.employement().controls[index].patchValue({
                    prvlWageSourceId: 'PWDLABDEPT'
                  });
                  break;
        case 'oes': 
                  this.removePrevailingWage(index);
                  this.employement().controls[index].get('pwdIssuedByLabor').clearValidators();
                  this.employement().controls[index].get('otherThanOES').clearValidators();
                  this.employement().controls[index].get('pwdIssuedByLabor').setValue('');
                  this.employement().controls[index].get('otherThanOES').setValue('');
                  this.employement().controls[index].get('pwdOesSourceLevelId').setValidators([Validators.required]);
                  this.employement().controls[index].get('pwdOesSourceYear').setValidators([Validators.required]);
                  this.employement().controls[index].get('countyAreaName').setValidators([Validators.required]);
                  this.employement().controls[index].get('pwdOesSourceLevelId').enable();
                  this.employement().controls[index].get('pwdOesSourceYear').enable();
                  this.employement().controls[index].get('countyAreaName').enable();
                  this.employement().controls[index].patchValue({
                    prvlWageSourceId: 'PWDOESPROG'
                  });
                  break;
        case 'other':
                  this.removePrevailingWage(index);
                  this.employement().controls[index].get('pwdIssuedByLabor').clearValidators();
                  this.employement().controls[index].get('OESProgram').clearValidators();
                  this.employement().controls[index].get('pwdIssuedByLabor').setValue('');
                  this.employement().controls[index].get('OESProgram').setValue('');
                  this.employement().controls[index].get('pwdOtherSourceId').setValidators([Validators.required]);
                  this.employement().controls[index].get('pwdOtherSourceYear').setValidators([Validators.required]);
                  this.employement().controls[index].get('pwdOtherSourceId').enable();
                  this.employement().controls[index].get('pwdOtherSourceYear').enable();
                  this.employement().controls[index].patchValue({
                    prvlWageSourceId: 'PWDOTHERLEGTSRC'
                  });
                  break;
        default:
                  this.removePrevailingWage(index);
                  break;
      }
    } else {
      this.removePrevailingWage(index);
      this.employement().controls[index].get('pwdIssuedByLabor').setValidators([Validators.required]);
      this.employement().controls[index].get('OESProgram').setValidators([Validators.required]);
      this.employement().controls[index].get('otherThanOES').setValidators([Validators.required]);
      this.employement().controls[index].get('pwdIssuedByLabor').setValue('');
      this.employement().controls[index].get('OESProgram').setValue('');
      this.employement().controls[index].get('otherThanOES').setValue('');
    }
  }

  removePrevailingWage(index){
    this.employement().controls[index].get('pwdTrackNumber').disable();
    this.employement().controls[index].get('pwdOesSourceLevelId').disable();
    this.employement().controls[index].get('pwdOesSourceYear').disable();
    this.employement().controls[index].get('countyAreaName').disable();
    this.employement().controls[index].get('pwdOtherSourceId').disable();
    this.employement().controls[index].get('pwdOtherSourceYear').disable();
    this.employement().controls[index].get('pwdTrackNumber').setValue('');
    this.employement().controls[index].get('pwdOesSourceLevelId').setValue('');
    this.employement().controls[index].get('pwdOesSourceYear').setValue('');
    this.employement().controls[index].get('countyAreaName').setValue('');
    this.employement().controls[index].get('pwdOtherSourceId').setValue('');
    this.employement().controls[index].get('pwdOtherSourceYear').setValue('');
  }

  onChangeOesSourceType(event, index){
    if(event.value === 'OTHER' && this.employement().controls[index].get('otherThanOES').value === true){
      this.employement().controls[index].get('otherPwdSurveyName').enable();
      this.employement().controls[index].get('otherPwdSurveyPublshr').enable();
      this.employement().controls[index].get('otherPwdSurveyName').setValidators([Validators.required]);
      this.employement().controls[index].get('otherPwdSurveyPublshr').setValidators([Validators.required]);
    } else {
      this.employement().controls[index].get('otherPwdSurveyName').disable();
      this.employement().controls[index].get('otherPwdSurveyPublshr').disable();
      this.employement().controls[index].get('otherPwdSurveyName').setValue('');
      this.employement().controls[index].get('otherPwdSurveyPublshr').setValue('');
    }
  }

  onChangeSecondaryEntity(value, index){
    if(!value){
      this.employement().controls[index].get('secEntBusName').setValue('');
      this.employement().controls[index].get('secEntBusName').clearValidators();
    } else {
      this.employement().controls[index].get('secEntBusName').setValidators([Validators.required,Validators.minLength(5)]);
    }
    this.employement().controls[index].get('secEntBusName').updateValueAndValidity();
  }

  getWageLevels(index, event, state) {
    let countyName = '';
    if (event.value) {
      countyName = event.value.toUpperCase();
    } else {
      countyName = event.toUpperCase();
    }
    let stateName = this.listStates.filter(eachState => eachState.stateProvinceCode === state).map(eachState => eachState.stateProvinceName);
    if(stateName && countyName.length > 0 && this.socCode){
      const reqArr = [this.lcaApis.getWagesOfLevels(this.socCode, stateName, countyName),this.lcaApis.getWagesOfLevels(this.socCode, stateName, countyName, true),this.lcaApis.getCountyAreas(state,countyName)];
      combineLatest(reqArr)
        .pipe(takeUntil(this.destroy$))
        .subscribe((response: any[]) => {
          if(response[0]?.data){
            if(!this.wageResults[index]) {
              this.wageResults.push(response[0].data[0]);
            } else {
              this.wageResults[index] = response[0].data[0];
            }
          }
          if(response[1]?.data){
            if(!this.wageResultsEducation[index]) {
              this.wageResultsEducation.push(response[1].data[0]);
            } else {
              this.wageResultsEducation[index] = response[1].data[0];
            }
          }
          if(response[2]?.data){
            if(!this.countyAreaList[index]) {
              this.countyAreaList.push(response[2]?.data);
            }else{
              this.countyAreaList[index] = response[2]?.data;
            }
          }
        });
    }
  }

  clearData() {
    // Clear any previous confirmation
    this.confirmationService.close();

    this.confirmationService.confirm({
      header: "Clear Data",
      icon: "pi pi-exclamation-triangle",
      rejectLabel: "Cancel",
      acceptLabel: "Yes, Clear Data",
      acceptButtonStyleClass: "btn-accept-clear",
      rejectButtonStyleClass: "btn-cancel-clear",
      message: `<div class="mb-4"> This will clear all the data from this section. </div>
                <div class="mb-4"> Are you sure, you want to clear data? </div>`,
      accept: () => {
        this.employmentWageForm.reset();
        this.confirmationService.close();
      },
      reject: () => {
        // Clear the confirmation dialog instance after rejection
       this.confirmationService.close();
     },
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
